import { useEffect, useRef, useState } from 'react';

/** Width of a container, tracked with ResizeObserver (SVG charts). */
export function useElementWidth<T extends HTMLElement>(): [React.RefObject<T | null>, number] {
    const ref = useRef<T | null>(null);
    const [width, setWidth] = useState(0);
    useEffect(() => {
        const element = ref.current;
        if (!element) return;
        if (typeof ResizeObserver === 'undefined') {
            setWidth(element.clientWidth);
            return;
        }
        // The observer reports the initial size as soon as observe() is called.
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) setWidth(Math.round(entry.contentRect.width));
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, []);
    return [ref, width];
}
